<script setup lang="ts">
import { computed } from 'vue';
import OverflowTooltip from '@/components/OverflowTooltip.vue';

/**
 * One-prop wrapper around the truncate + overflow-tooltip pattern, for ad-hoc table cells
 * outside the column-mapping registry that also need to clamp long text and surface the full
 * value on hover. Delegates to OverflowTooltip, which lazily instantiates the tooltip only on
 * hover of an overflowing cell, so a table of these costs nothing per cell until hovered.
 */
const props = defineProps<{
  value: string | null | undefined;
  /** Tailwind classes added to the visible truncated span (e.g. 'font-mono'). */
  textClass?: string;
  /** Tailwind classes added to the tooltip body (e.g. 'font-mono'). */
  contentClass?: string;
}>();

const displayValue = computed(() => props.value ?? '');
const tooltipContentClass = computed(() =>
  ['max-w-xs break-words pointer-events-none', props.contentClass].filter(Boolean).join(' '),
);
</script>

<template>
  <OverflowTooltip
    :deps="displayValue"
    :trigger-class="textClass"
    :content-class="tooltipContentClass"
  >{{ displayValue }}</OverflowTooltip>
</template>
